import { http } from '../../../plugins/axios'

const actions = {
  getAllItems ({commit}, payload) {
    let url = 'unit'
    let options = {
      emulateJSON: false
    }
    let params = {
      'plate_number': payload.event.plate_number ? payload.event.plate_number : undefined,
      'unit_number': payload.event.unit_number ? payload.event.unit_number : undefined,
      'unit_types_alias': payload.event.unit_types_alias ? payload.event.unit_types_alias : undefined,
      'sites_name': payload.event.sites_name ? payload.event.sites_name : undefined,
      'owner': payload.event.owner ? payload.event.owner : undefined,
      'status': payload.event.status ? payload.event.status : undefined,
      'perPage': payload.event.options.perPage,
      'page': payload.event.options.page,
      'find': payload.event.options.find != '' ? payload.event.options.find : undefined,
      'sortKey': payload.event.options.sortKey ? payload.event.options.sortKey : 'id',
      'ord': payload.event.options.ord,
      'is_damage': 1 //Agregado manualmente por requerimiento del endpoint
    }
    http.get(url, { params }, options).then(
      response => {
        commit('onGetAllItems', { event: payload.event, response })
      },
      error => {
        commit('onError', { event: payload.event, error })
      }
    )
  },
  getGraphic ({commit}, payload) {
    let url = 'inspection-heatmap'
    let options = {
      emulateJSON: false
    }
    let params = {
      'unit_id': payload.event.map.unit,
      'year': payload.event.map.year
    }
    http.get(url, { params }, options).then(
      response => {
        commit('onGetGraphic', { event: payload.event, response })
      },
      error => {
        commit('onError', { event: payload.event, error })
      }
    )
  },
  getPDFByID({ commit }, payload) {
    const inspectionId = payload.event.inspection;
    // let url = `pdf-generate/${inspectionId}?force_generate=1`; // ELIMINAR PARA PRODUCCIÓN, SOLO PRUEBAS
    let url = `pdf-generate/${inspectionId}`;
    http
      .get(url, { responseType: "blob" })
      .then((response) => {
        commit("onGetPDFByID", { event: payload.event, response });
      })
      .catch((error) => {
        payload.event.context.$set(
          payload.event.context.loadReport,
          inspectionId,
          false
        );
        commit("onError", { event: payload.event, error });
      });
  },
}
export default actions
